import { useLocation } from "react-router-dom";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import { API_BASE_URL, DEFAULT_PAGE_DESCRIPTION, DEFAULT_PAGE_TITLE } from "../../utilities/constants";
import { useEffect, useState } from "react";
import { handleApiCall } from "../../utilities/helper";
import Spinner from "../../components/ui/Spinner";
import GeneratedLooksCard from "../generatedlooks/GeneratedLooksCard";

const LookGenerationResults = () => {
    const location = useLocation();
    const { jobId } = location.state || {};
    const [lookData, setLookData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [controller, setController] = useState(null);
    const { stylist } = location.state || {};
    console.log("STYLIST Look Generation Results", stylist);

    const callListApi = async () => {
        if (!jobId) return;

        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);

        try {
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/aigenlook/v2/look-job/${jobId}`,
                {
                    method: "GET"
                },
                null,
                signal
            );

            if (response.responseStatus === true) {
                setLookData(response.data);
            } else {
                setLookData(null);
            }
        } catch (e) {
            console.error("Error fetching look results:", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        callListApi();
        return () => controller?.abort();
    }, [jobId]);

    return (
        <>
            <PageMeta
                title={`Generated Looks Results - ${DEFAULT_PAGE_TITLE}`}
                description={`View the results of your AI look generation - ${DEFAULT_PAGE_DESCRIPTION}`}
            />

            <div className="flex justify-between items-center mb-4">
                <PageBreadcrumb
                    pageTitle="Generated Looks Results"
                    breadcrumbs={[
                        { label: "Look Generation", path: "/lookgen" },
                        { label: "Results" },
                    ]}
                />
            </div>

            {loading ? (
                <div className="flex justify-center items-center py-20">
                    <Spinner />
                </div>
            ) : !jobId ? (
                <div className="bg-white dark:bg-gray-800 p-10 rounded-xl text-center shadow-sm">
                    <p className="text-gray-600 dark:text-gray-400">No job ID found. Please generate looks first.</p>
                </div>
            ) : (
                <div className="bg-gray-50 dark:bg-gray-900 rounded-xl">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {lookData?.looks?.map((look) => (
                            <GeneratedLooksCard key={look?.lookId || look?.jobId} look={look} stylist={stylist} />
                        ))}
                        {lookData?.looks?.length === 0 && (
                            <div className="col-span-full py-10 text-center">
                                <p className="text-gray-500">No looks were generated for this request.</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default LookGenerationResults;
